import React, { useEffect, useRef } from 'react';

// Decorative motion lives outside the content and never intercepts input.
export default function AmbientScene({ paused }) {
  const scene = useRef(null);

  useEffect(() => {
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (paused || reduced.matches || !window.matchMedia('(pointer: fine)').matches) return;
    let frame = null;
    const move = (event) => {
      if (frame !== null) cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        scene.current.style.setProperty('--pointer-x', `${event.clientX}px`);
        scene.current.style.setProperty('--pointer-y', `${event.clientY}px`);
      });
    };
    window.addEventListener('pointermove', move, { passive: true });
    return () => {
      window.removeEventListener('pointermove', move);
      if (frame !== null) cancelAnimationFrame(frame);
    };
  }, [paused]);

  return (
    <div ref={scene} className="ambient-scene" aria-hidden="true">
      <div className="ambient-orbit ambient-orbit--one" />
      <div className="ambient-orbit ambient-orbit--two" />
      <div className="ambient-pointer" />
      <span className="ambient-spark ambient-spark--one" />
      <span className="ambient-spark ambient-spark--two" />
      <span className="ambient-spark ambient-spark--three" />
    </div>
  );
}
